import apiClient from "../utils/axiosConfig";
import { getApiUrl, API_ENDPOINTS } from "../Configurations/config";

/**
 * Suggestion Service - Handles all suggestion related API calls
 */
class SuggestionService {
  /**
   * Get suggestions based on user query and bot response
   * @param {string} userQuery - User's query
   * @param {string} sqlQuery - SQL query that was executed
   * @param {string} response - Bot's response
   * @param {string} sessionId - Session ID
   * @param {string} userId - User ID (optional, from login)
   * @returns {Promise} API response with suggestions array
   */
  async getSuggestions(userQuery, sqlQuery, response, sessionId, userId = null) {
    try {
      const requestBody = {
        user_query: userQuery,
        sql_query: sqlQuery,
        response: response,
        session_id: sessionId,
      };

      if (userId) {
        requestBody.user_id = userId;
      }

      const response_data = await apiClient.post(
        getApiUrl(API_ENDPOINTS.QUERY.SUGGESTIONS),
        requestBody
      );

      return response_data.data;
    } catch (error) {
      throw error;
    }
  }
}

export const suggestionService = new SuggestionService();
export default suggestionService;

